export const formElement = { value: null, errors: [], touched: false, options: [], commercial: false, formKey: '' };
export const formSchema = {
  lastMile: { ...formElement },
  pop: { ...formElement },
  cloud: { ...formElement },
  ipVersion: { ...formElement },
  routingProtocol: { ...formElement },
  qos: { ...formElement },
  business: { ...formElement },
  prt: { ...formElement },
  pnrt: { ...formElement },
  standard: { ...formElement },
  vpnType: { ...formElement },
  vpnTopology: { ...formElement },
  linkTopology: { ...formElement },
  redundancy: { ...formElement },
  manageability: { ...formElement },
  portBandwidth: { ...formElement },
  accessBandwidth: { ...formElement },
  cpeType: { ...formElement },
  isRecordAvailable: false
};

const getSpecsObject = (rawData) => {
  const {
    allRecords: { content: contents = [] },
    locationId
  } = rawData;
  if (Array.isArray(contents)) {
    return contents?.filter((content) => {
      return content?.lineItemId === locationId;
    });
  }
  return [];
};

const getSpecsForSummary = (rawData) => {
  const { allRecords, rawContent } = rawData;
  if (Array.isArray(allRecords)) {
    return allRecords?.filter((content) => {
      return content?.linkId === rawContent?.linkId;
    });
  }
  return [];
};

export const getDefaultValue = (rawData, linkType, isSummaryRender) => {
  const form = { ...formSchema };
  const contents = isSummaryRender ? getSpecsForSummary(rawData) : getSpecsObject(rawData);
  contents.forEach((record) => {
    let specs;
    let siteType;
    if (!isSummaryRender) {
      specs = record?.rawContent?.planDetail?.specs;
      siteType = record?.rawContent?.siteType;
    } else {
      specs = record?.planDetail?.specs;
      siteType = record?.siteType;
    }
    specs?.forEach((spec) => {
      if (siteType === linkType) {
        const fields = spec.name;
        form[fields] = { ...form[spec.name], value: spec.value };
        form['isRecordAvailable'] = siteType === linkType;
      }
    });
  });
  form['manageability'] = { ...form['manageability'], value: '' };
  return form;
};

export const LINK_TYPE = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY'
};
